/* eslint-disable import/prefer-default-export */
import moment from 'moment';

/**
 * Will return the month name for the given month number.
 * Expects numbers from 1-12, with 1 = Jan, 2 = Feb, etc.
 *
 * @param {number} monthInt - the integer for the month name to return. Expects numbers from 1-12, with 1 = Jan,
 *                            2 = Feb, etc.
 * @param {string} [format = 'MMMM'] - optional moment month format. The default of 'MMMM' will return the full version
 *                                     of the month name. The next most commonly used will be 'MMM', which will return
 *                                     the shortform version of the month (Jan, Feb, Mar, etc).
 * @returns {string} - the month name
 */
export function monthNumberToName(monthInt, format = 'MMMM') {
    return moment(monthInt, 'M').format(format);
}
